import { Injectable } from '@angular/core';
import { PaymentHistory } from './payment-history.types';
import { PagedList, PagedFilter } from '../../common/common.types';
import { Http } from '@angular/http';

@Injectable()
export class PaymentHistoryService {
	private myPaymentHistoryUrl = 'api/me/paymenthistory';
	private customerPaymentHistoryUrl = (customerId: number) => `api/customers/${customerId}/paymenthistory`;
	constructor(private _http: Http) { }

	getPaymentHistory(filter?: PagedFilter, customerId?: number): Promise<PagedList<PaymentHistory>> {
		const url = customerId ? this.customerPaymentHistoryUrl(customerId) : this.myPaymentHistoryUrl;
		return this._http.get(url, { params: filter })
						.toPromise()
						.then(response => response.json() as PagedList<PaymentHistory>);
	}
}
